import { render, staticRenderFns } from "./RecipePage.vue?vue&type=template&id=55164ff1&"
import script from "./RecipePage.vue?vue&type=script&lang=js&"
export * from "./RecipePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports